import { ChakraWrap, ChakraWrapItem } from '@equip.health/ui';
import Loading from '~/pages/loading';

import ReportListItem from './ReportListItem';
import { useGetUserReportsQuery } from '~/store/services/reports';

const TOP_LEVEL_ID = 'reports-list';

const ReportsList = () => {
  const { data: reports, isLoading: isGetReportsLoading } =
    useGetUserReportsQuery();
  if (isGetReportsLoading) return <Loading />;

  return (
    <ChakraWrap
      id={TOP_LEVEL_ID}
      paddingBottom="16px"
      paddingTop="28px"
      spacing="16px"
    >
      {(reports ?? []).map(({ description, name, reportId }) => (
        <ChakraWrapItem key={reportId}>
          <ReportListItem
            description={description}
            name={name}
            reportId={reportId}
          />
        </ChakraWrapItem>
      ))}
    </ChakraWrap>
  );
};
export default ReportsList;
